import { render, staticRenderFns } from "./ExportBarcode.vue?vue&type=template&id=4922cabf&"
import script from "./ExportBarcode.vue?vue&type=script&lang=js&"
export * from "./ExportBarcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports